import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class PortInput extends TextInput {}

registerCustomElement('imt-input-port', PortInput);
